import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  header: {
    defaultMessage: 'Import Locations from CSV',
    id: 'khTEdh',
    description: 'Location Import Modal Title',
  },
  createConfigStep: {
    defaultMessage: 'Upload File',
    id: 'IQ2vdL',
    description: 'Title on the first step of the import process',
  },
  createMappingStep: {
    defaultMessage: 'Match Fields',
    id: 'ZUIKqi',
    description: 'Create mapping step title message',
  },
  importResult: {
    id: 'w4K8Ut',
    defaultMessage: 'Import Locations',
    description: 'Title of import is processing step',
  },
  importResultSuccess: {
    id: 'UTEz8n',
    defaultMessage: 'Locations Successfully Imported',
    description: 'Title of success import',
  },
});

export const fieldsTranslations = defineMessages({
  loc_1: {
    defaultMessage: 'Area',
    id: 'iZN02y',
    description: 'Area inventory import column name',
  },
  loc_2: {
    defaultMessage: 'Unit',
    id: 'wmC1uD',
    description: 'Unit inventory import column name',
  },
  loc_3: {
    defaultMessage: 'Shelf',
    id: 'mkgQQg',
    description: 'Shelf inventory import column name',
  },
  loc_4: {
    defaultMessage: 'Bin',
    id: 'TrWzPP',
    description: 'Bin inventory import column name',
  },
  barcode: {
    defaultMessage: 'Barcode',
    id: 'P3v6IH',
    description: 'Barcode inventory import column name',
  },
});
